import * as React from "react";
import { SVGProps, memo } from "react";

const SvgReceiveMail = (props: SVGProps<SVGSVGElement>) => (
  <svg width={59} height={42} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#ReceiveMail_svg__a)">
      <rect x={0.5} y={10} width={48} height={32} rx={4} fill="#E7F4FD" />

      <path
        opacity={0.5}
        d="M46.62 36.825c1.17.731 2.009 2.108 1.282 3.28A3.997 3.997 0 0 1 44.5 42h-40a3.998 3.998 0 0 1-3.402-1.895c-.727-1.172.112-2.549 1.282-3.28L24.5 23l22.12 13.825Z"
        fill="#A1D5F7"
      />

      <path
        d="M2.38 15.175c-1.17-.731-2.009-2.108-1.282-3.28A3.998 3.998 0 0 1 4.5 10h40c1.437 0 2.696.757 3.402 1.895.727 1.172-.113 2.549-1.282 3.28L24.5 29 2.38 15.175Z"
        fill="#fff"
      />

      <rect
        x={1.3}
        y={10.8}
        width={46.4}
        height={30.4}
        rx={3.2}
        stroke="#2B323B"
        strokeWidth={1.6}
        strokeLinecap="round"
      />
    </g>

    <path d="m1.5 14 23 15 23-15" stroke="#2B323B" strokeWidth={1.6} strokeLinecap="round" />

    <path
      d="M58.5 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Z"
      fill="#0F72BD"
    />

    <path
      d="M46.5 6.657c.242 0 .478-.028.707-.086.229-.057.434-.152.616-.285.189-.134.347-.305.475-.515.135-.21.222-.466.263-.771h.939v10h-1.263V7.943H46.5V6.657Z"
      fill="#fff"
    />

    <defs>
      <clipPath id="ReceiveMail_svg__a">
        <path fill="#fff" transform="translate(.5 10)" d="M0 0h48v32H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgReceiveMail);

export default Memo;
